<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('academy.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'college', params: { id: college.id } }">{{ $t('academy.title') }}：{{ college.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-dropdown no-flip :text="department.name">
          <b-dropdown-item
            v-for="department in college_departments"
            :to="{ name: 'department', params: { id: department.id } }"
          >{{ department.name }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4>{{ department.name }}</h4>
        <p><strong>{{ $t('department.detail.label.lecturer') }}：</strong>{{ department.lecturer.lecr_full_name }}</p>
        <p>
          <strong>{{ $t('department.detail.label.lecturer-introduction') }}：</strong>
          <span v-html="department.lecturer.intro"></span>
        </p>
        <p>
          <strong>{{ $t('department.detail.label.time') }}：</strong>
          {{ days_of_week[department.week == 7 ? 0 : department.week] }}
          {{ department.spk_start_time }} ~ {{ department.spk_end_time }}
        </p>
        <p>
          <strong>{{ $t('department.detail.label.livestream-and-recording') }}：</strong><br>
           {{ $t('department.detail.label.livestream') }} {{ department.streaming == 'Y' ? '√' : 'X' }}<br>
           {{ $t('department.detail.label.recording') }} {{ department.recording == 'Y' ? '√' : 'X' }}
        </p>
        <p>
          <strong>{{ $t('department.detail.label.course-plan') }}：</strong><br>
          <span v-html="department.course_plan"></span>
        </p>
        <social-sharing-button-toolbar
          :title="social_sharing_title"
          :to="social_sharing_route"
        ></social-sharing-button-toolbar>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { DropdownPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

import i18n from '@/plugins/i18n.js'

import CollegeDepartmentApiService from '@/services/budaedu-api-services/college-department-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(DropdownPlugin)
Vue.use(IconsPlugin)

Vue.use(CollegeDepartmentApiService)

export default {
  i18n,
  name: 'department',
  props: {
    id: {
      type: Number,
      required: true
    }    
  },
  data() {
    return {
      department: null,
      college: null,
      college_departments: []
    }
  },
  computed: {
    social_sharing_title() {
      return `${this.$t('academy.title')} ${this.college.name} ${this.department.name}`;
    },
    social_sharing_route() {
      return { name: 'department', params: { id: this.department.id } }
    },
    days_of_week() {
      return [
        this.$t('days-of-week.sunday.full'),
        this.$t('days-of-week.monday.full'),
        this.$t('days-of-week.tuesday.full'),
        this.$t('days-of-week.wednesday.full'),
        this.$t('days-of-week.thursday.full'),
        this.$t('days-of-week.friday.full'),
        this.$t('days-of-week.saturday.full')
      ]
    }
  },
  methods: {
    async setDepartment() {
      const { data } = await this.$collegeDepartmentApiService.getById(
        this.id,
        'include=college.departments,lecturer'
      )

      this.department = data
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setDepartment()
    this.college = this.department.college
    this.college_departments = this.college.departments
  },
  components: {
    SocialSharingButtonToolbar
  },
  metaInfo() {
    const title = this.department
      ? `${this.$t('academy.title')}-${this.college.name}-${this.department.name}`
      : `${this.$t('academy.title')}`
    
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>